export default __webpack_public_path__ + "static/media/Group 3200.ca2c7f9e.svg";